import React from 'react';

export default function ProblemEditor() {
  return (
    <div className="problem-editor">
      <span>Problem</span>
    </div>
  );
}
